import { ReactNode, useState } from "react";
import { Button } from "primereact/button";

import S from "../_styles.module.scss";
import { themeClasses as T, C } from "sj-ui-toolkit/src/atlas/utils/themeClasses";

// The markdown `pre` node passed by react-markdown (a hast Element). We only read the nested
// pre > code > text value, so keep the prop loose and narrow the traversal below.
interface CodeBlockProps {
  node?: { children?: unknown[] };
  children?: ReactNode;
}

const CodeBlock = ({ node, children }: CodeBlockProps) => {
  const [codeCopied, setCodeCopied] = useState(false);

  const codeElement = node?.children?.[0] as { children?: Array<{ value?: string }> } | undefined;
  const codeChunk = codeElement?.children?.[0]?.value ?? "";
  const handleCopyCode = (chunk: string) => {
    setCodeCopied(true);
    navigator.clipboard.writeText(chunk);
    setTimeout(() => {
      setCodeCopied(false);
    }, 3000);
  };
  return (
    <div className={C(S.instructionCodeBlock, T.bgElevation1)}>
      <div className="flex justify-end self-stretch items-start">
        <Button
          label="Copy"
          icon={codeCopied ? "pi pi-file-check" : "pi pi-copy"}
          iconPos="right"
          size="small"
          text
          onClick={() => handleCopyCode(codeChunk)}
        />
      </div>
      <pre tabIndex={0} aria-label="Code snippet" className={T.scrollbar}>
        {children}
      </pre>
    </div>
  );
};

export default CodeBlock;
